import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header/header";
import Footer from "./components/footer/footer";
import Homepage from "./page/homepage"
import Whopage from "./page/whopages"
import Servicespage from "./page/servicespage";
import Doctors from "./page/doctors";
import Team from "./components/team/team";
import Contactpage from "./page/contactpage";
import Reservations from "../src/components/Reservations/Reservations"
import Blogpage from "./page/blogpage";
// start services

import OneServices from "../src/components/services detials/oneservices"
import TwoServices from "../src/components/services detials/twoservies"
import ThreeServices from "../src/components/services detials/threeservice"
import FourServices from "../src/components/services detials/fourservice"
import FiveServices from "../src/components/services detials/fiveservice"
import SixServices from "../src/components/services detials/sixservice"
import SevenServices from "../src/components/services detials/sevenservice"
import EightServices from "../src/components/services detials/eightservice"

// start blog

import Oneblog from "./components/blog detials/oneblog";
import Twoblog from "./components/blog detials/twoblog";
import Threeblog from "./components/blog detials/threeblog";
import Fourblog from "./components/blog detials/blogfour";
import Fiveblog from "./components/blog detials/blogfive";
import Sixblog from "./components/blog detials/blogsix";
import Login from "./components/Login/login";
import Register from "./components/Register/register";
function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/Medora-Center">
            <Header/>
      <Routes>
        <Route path="/" element={<Homepage/>}></Route>
        <Route path="/about" element={<Whopage/>}></Route>
        <Route path="/Services" element={<Servicespage/>}></Route>
        <Route path="/Doctors" element={<Doctors/>}></Route>
        <Route path="/Contact" element={<Contactpage/>}></Route>
        <Route path="/Booking" element={<Reservations/>}></Route>
        <Route path="/Blog" element={<Blogpage/>}></Route>
        <Route path="/oneservices" element={<OneServices/>}></Route>
        <Route path="/twoservices" element={<TwoServices/>}></Route>
        <Route path="/threeservices" element={<ThreeServices/>}></Route>
        <Route path="/fourservices" element={<FourServices/>}></Route>
        <Route path="/fiveservices" element={<FiveServices/>}></Route>
        <Route path="/sixservices" element={<SixServices/>}></Route>
        <Route path="/oneblog" element={<Oneblog/>}></Route>
        <Route path="/twoblog" element={<Twoblog/>}></Route>
        <Route path="/threeblog" element={<Threeblog/>}></Route>
        <Route path="/fourblog" element={<Fourblog/>}></Route>
        <Route path="/fiveblog" element={<Fiveblog/>}></Route>
        <Route path="/sixblog" element={<Sixblog/>}></Route>
        <Route path="/login" element={<Login/>}></Route>
        <Route path="/register" element={<Register/>}></Route>






      </Routes>
        <Footer/>
      </BrowserRouter>
    </div>
  );
}

export default App;
